import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Student } from '../../../../models/student.model';
import { Gender } from '../../../../../genders/models/gender.model';

@Component({
  selector: 'app-student-edit-general',
  templateUrl: './student-edit-general.component.html',
  styleUrls: ['./student-edit-general.component.scss']
})
export class StudentEditGeneralComponent implements OnInit {

    @Input() student : Student;
    @Input() genders : Gender[];
    @Input() readonly: boolean = false;

    @Output() studentChange  = new EventEmitter<Student>();
    @Output() isStudentValid = new EventEmitter<boolean>();

    public selectedGender: Gender;

    ngOnInit (): void {

        if (this.student.birthDate) {
            this.student.birthDate = new Date(this.student.birthDate);
        }

        if (this.student.genderId) {
            this.selectedGender          = new Gender();
            this.selectedGender.genderId = this.student.genderId;
            this.selectedGender.name     = this.student.genderName;
        }

        this.onStudentChange();

    }

    public onSelectedGenderChange() {

        this.student.genderId   = this.selectedGender?.genderId;
        this.student.genderName = this.selectedGender?.name;

        this.onStudentChange();

    }

    private isFormValid() : boolean {

        let isValidName       = this.student.name && this.student.name !== null && this.student.name !== '';
        let isValidSurname    = this.student.surname && this.student.surname !== null && this.student.surname !== '';
        let isValidBirthDate  = this.student.birthDate && this.student.birthDate !== null;
        let isValidGender     = this.student.genderId && this.student.genderId !== null && this.student.genderId !== 0;

        return isValidName && isValidSurname && isValidBirthDate && isValidGender;

    }

    public onStudentChange() {

        let isFormValid = this.isFormValid();
        this.isStudentValid.emit(isFormValid);

        if (isFormValid) { this.studentChange.emit(this.student); }

    }

}
